import { render, staticRenderFns } from "./plotBookComponent.vue?vue&type=template&id=48f1637c&scoped=true&"
import script from "./plotBookComponent.vue?vue&type=script&lang=js&"
export * from "./plotBookComponent.vue?vue&type=script&lang=js&"
import style0 from "./plotBookComponent.vue?vue&type=style&index=0&id=48f1637c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f1637c",
  null
  
)

export default component.exports